export const QUERY_KEYS = {
  getUserContextToken: ["getUserContextToken"],
  getUserAssignments: ["assignments"],
};
